/**
 * How the persona editor offers the Kokoro (local) voice provider (SA-1392).
 *
 * Kokoro speaks only where the deployment has local TTS (`localTts` from
 * `useEdgeLocalConfig`). Elsewhere it is not offered, except on a persona
 * already saved with it, where it shows as unavailable so the person sees
 * why it is silent there. While local TTS is unknown, such a persona keeps
 * its option as it is, so a slow read never flashes a warning.
 */
import type { VoiceProvider } from '@/stores/personaStore'

export type KokoroOption = 'offered' | 'unavailable' | 'kept' | 'hidden'

export const KOKORO_LABEL = 'Kokoro (Local)'
export const KOKORO_UNAVAILABLE_LABEL = 'Kokoro (Local), not available on this deployment'
export const KOKORO_UNAVAILABLE_HINT =
  'This deployment has no local text-to-speech. Choose another provider.'

export function kokoroOption(
  localTts: boolean | null,
  savedProvider: VoiceProvider | undefined,
): KokoroOption {
  if (localTts === true) return 'offered'
  if (savedProvider !== 'kokoro') return 'hidden'
  return localTts === false ? 'unavailable' : 'kept'
}
